import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const ESuccessCodes = {
	OK: '200',
	Created: '201',
	Accepted: '202',
} as const;

export type TSuccessCodes = TValueOfStringRecord<typeof ESuccessCodes>
